import { render, staticRenderFns } from "./Create-Bug-Report.vue?vue&type=template&id=7c28c4fd"
import script from "./Create-Bug-Report.vue?vue&type=script&lang=js"
export * from "./Create-Bug-Report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports